import { render, staticRenderFns } from "./infoPage.vue?vue&type=template&id=2e632cdb&scoped=true"
import script from "./infoPage.vue?vue&type=script&lang=js"
export * from "./infoPage.vue?vue&type=script&lang=js"
import style0 from "./infoPage.vue?vue&type=style&index=0&id=2e632cdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e632cdb",
  null
  
)

export default component.exports